class Lightbox{
    constructor(images, startindex, options){
        if (typeof images == 'string') {
            images = [images];
        }
        this._images = images;

        if (typeof startindex == 'undefined') {
            startindex = 0;
        }
        this._index = startindex;

        var defaultoptions = {
            delete: null,
            title: null,
            arrows: true,
        }

        if (typeof options == 'undefined') {
            options = {};
        }
        this._options = {
            ...defaultoptions,
            ...options
        };
    }
    show(){
        var self = this;

        this._lightbox = document.createElement('div');
        this._lightbox.classList = 'lightbox';
        this._lightbox.style = 'position:relative;z-index:999;';

        var bg = document.createElement('div');
        bg.classList = 'lightbox__background';
        bg.style = 'position:fixed;left:0;top:0;background-color:rgba(0,0,0,0.8);width:100%;height:100%;';
        bg.addEventListener('click', function(){
            document.body.removeChild(self._lightbox);
        });

        this._lightbox.appendChild(bg);

        var wrapper = document.createElement('div');
        wrapper.classList = 'lightbox__image-wrapper';
        wrapper.style = 'position:fixed;left:0;top:0;height:100%;width:100%;display:flex;align-items:center;justify-content:center;pointer-events:none;';

        var image_container = document.createElement('div');
        image_container.classList = 'lightbox__image';
        image_container.style = 'position:relative;pointer-events:all;';

        wrapper.appendChild(image_container);

        this._img = document.createElement('img');
        this._img.style = 'max-width:90vw;max-height:calc(90vh - 40px);width:auto;display: block;';
        this._img.src = this._images[this._index];

        image_container.appendChild(this._img);

        var actionbar = document.createElement('div');
        actionbar.style = 'position:absolute;height:50px;left:10px;right:10px;pointer-events:all;bottom:10px;display:flex;justify-content:space-between;';
        wrapper.appendChild(actionbar);

        if (this._images.length > 1 && this._options.arrows) {
            var arrows = document.createElement('div');
            var arrow_left = document.createElement('button');
            arrow_left.style = 'width:50px;height:50px;border:none;background:none;padding:5px;opacity:0.6;';
            arrow_left.innerHTML = '<svg style="max-width:100%;max-height:100%;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 520.8 980" x="0px" y="0px" viewBox="0 0 520.8 980"><g><g><path d="M61.8,490l459-459.1L489.9,0,0,490,489.9,980l30.9-30.9Z" style="fill:#fff"/></g></g></svg>';
            arrow_left.addEventListener('click', () => {this.previous(this)});
            arrows.appendChild(arrow_left);

            var arrow_right = document.createElement('button');
            arrow_right.style = 'width:50px;height:50px;border:none;background:none;padding:5px;opacity:0.6;';
            arrow_right.innerHTML = '<svg style="max-width:100%;max-height:100%;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 520.8 980" x="0px" y="0px"><g><g><path d="M459,490,0,949.1,30.9,980,520.8,490,30.9,0,0,30.9Z" style="fill:#fff"/></g></g></svg>';
            arrow_right.addEventListener('click', () => {this.next(this)});
            arrows.appendChild(arrow_right);

            actionbar.appendChild(arrows);
        }

        if (this._options.delete) {
            var btn_delete = document.createElement('button');
            btn_delete.style = 'width:50px;height:50px;border:none;background:none;padding:5px;opacity:0.6;margin-left:auto;';
            btn_delete.innerHTML = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve"><g><path fill="#ffffff" d="M745,990H240.4c-42.6-12-73.2-37.7-76.2-82.5c-6.4-95.5-12.2-190.9-18.2-286.4c-7.2-114-14.3-228-21.6-342c-1.1-17-2.4-29.9-3.8-48H10v-51c2.4,0.2,4.8,0.6,7.2,0.6c82.5,0.1,160.9,0.1,243.4,0c3.3,0,6.6-0.4,11.4-0.7c0-26.9,0-48.8,0-74.8c0.1-29.8,14.3-60.9,39.8-78.1c10.9-7.4,24.2-11.4,36.4-17h288.7c2.2,0.9,4.3,2,6.6,2.7c38.1,10.9,66,43.5,68.9,82.5c1.7,22.7,0.6,41.5,0.8,64.3c0,6.8,0,13.7,0,21.2h20.1c79.6,0,155-0.1,234.6,0.2c7.3,0,14.7,3.1,22,4.8v39.6c-5.7,2-11.3,5.5-17.1,5.7c-20.4,0.7-40.8,0.3-61.2,0.3h-46.5c-0.8,4.7-1.4,7.4-1.6,10.2c-7,109.8-14,215.5-20.9,325.2c-7.2,113.5-14.2,227.2-21.4,340.8c-1.2,19-7.3,36.2-19.5,51.3C788.1,975.6,765.1,983.8,745,990L745,990z M168.7,232.1c1,17.8,1.8,30.3,2.8,46.9c7.3,115.9,14.8,231.9,22.2,347.8c5.2,82.6,9.9,165.4,15.6,248c3,44.1,14,72.6,75.1,72.6c136.1,0.2,281.1,0.3,417.2,0c59.3,0,71.7-29.2,74.6-73.1c5.5-81.2,10.2-162.5,15.3-243.8c6.4-102.1,13-204.3,19.5-306.4c2-31.7,3.8-59.4,5.7-92C600.6,232.1,385.6,232.1,168.7,232.1L168.7,232.1z M665.7,180.1c0-30.1,1-54.6-0.3-83c-1.1-22.8-19.1-38.8-42.3-38.9c-87-0.3-173.9-0.3-260.9,0c-20.7,0.1-38.8,12.6-40.3,32.2c-2.5,31-0.7,58.2-0.7,89.7L665.7,180.1L665.7,180.1z M365.7,588.7c0,77.6,0,155.1,0,232.7c0,19.1-3.9,20.2-23.4,20.3c-21,0.1-25.5-1.4-25.5-19.9c0-156.1-0.1-312.1,0.3-468.1c0-6.5,3.9-17.7,7.9-18.6c9.7-2.3,26.4-0.7,36.4,1.6c2.6,0.6,4.2,9.9,4.2,15.2C365.7,430.7,365.7,509.7,365.7,588.7L365.7,588.7z M468.2,587.1c0-77.5,0-155.1,0-232.7c0-19.5,4.6-21.4,24.1-21.4c20.4,0,24.9,1.6,24.9,20.6c0,156.1,0,312.1,0,468.2c0,18.6-4.2,19.8-25.6,19.8c-19.4-0.1-23.5-1.3-23.5-20.4C468.2,743.2,468.2,665.2,468.2,587.1L468.2,587.1z M622.5,588.5c0-78,0-156.1,0-234.1c0-20,1.4-21.3,21.2-21.4c20.4,0,24.9,1.7,24.9,22.1c0,155.1,0.1,310.2-0.3,465.3c0,6.7-3.1,18.2-7,19.2c-9.7,2.5-23.8,1.4-33.8-0.9c-2.8-0.6-4.9-10.6-4.9-16.2C622.4,744.5,622.5,666.5,622.5,588.5L622.5,588.5z"/></g></svg>';
            btn_delete.addEventListener('click', () => {this._options.delete(this._index); this.destroy(); });
            actionbar.appendChild(btn_delete);
        }

        if (this._options.title) {
            var titlebar = document.createElement('div');
            titlebar.style = 'font-weight:bold;position:absolute;top:100%;margin-top:10px;left:0;width:100%;font-size:0.8em;color:#ffffff;text-transform:uppercase;text-align:center;';
            titlebar.innerHTML = '<span style="display:inline-block;padding:5px 10px;background-color:#F43E3F;border-radius:5px;max-width:100%;"><span style="position:relative;top:1px;">' + this._options.title + '</span></span>';
            image_container.appendChild(titlebar);
        }

        this._lightbox.appendChild(wrapper);

        document.body.append(this._lightbox);
    }

    destroy(){
        document.body.removeChild(this._lightbox);
    }

    next(self){
        self._index += 1;
        if (!self._images[self._index]) {
            self._index = 0;
        }
        self._img.src = self._images[self._index];
    }

    previous(self){
        self._index -= 1;
        if (!self._images[self._index]) {
            self._index = self._images.length-1;
        }
        self._img.src = self._images[self._index];
    }
}

export default Lightbox;